import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, provide, nextTick, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import "vant/es/toast/style";
import "vant/es/notify/style";
import "vant/es/dialog/style";
import {
  initChannelCode,
  removeCodeFromUrl,
  hasValidCode as checkHasValidCode,
} from "./utils/channelCode";
import CustomerService from "@/components/CustomerService.vue";
import { Dialog } from "vant";

export default /*#__PURE__*/_defineComponent({
  name: 'App',
  setup(__props) {

const Vheight = document.documentElement.clientHeight + "px";
const customerServiceVisible = ref(false);
const route = useRoute();
const handleShowCustomerService: () => void = () => {
  customerServiceVisible.value = true;
};
const handleCloseCustomerService: () => void = () => {
  customerServiceVisible.value = false;
};

provide("handleShowCustomerService", handleShowCustomerService);
provide("handleCloseCustomerService", handleCloseCustomerService);
// 判断是否有有效的code参数
const hasValidCode = ref(false);

onMounted(() => {
  // 初始化channelCode
  initChannelCode();

  // 检查是否有有效的code（URL或缓存中）
  hasValidCode.value = checkHasValidCode();
  console.log(hasValidCode.value)
  if (!hasValidCode.value) {
    Dialog.alert({ title: "提示", message: "您访问的地址无效" }).then(() => {
      location.replace("/NoPermission");
    });
    // 可以在这里添加提示用户的逻辑，例如显示模态框
  } else {
    // 如果是从URL获取的code，移除URL中的参数
    // removeCodeFromUrl();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ]),
      _: 1
    }),
    _createVNode(CustomerService, {
      modelValue: customerServiceVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerServiceVisible).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})